<script setup lang="ts">
import { toCragViewModel } from '../../viewmodels/crag.ts';
import CragModel from '../../../core/crag_model';
import { computed } from 'vue';
import LineThumbnailView from './line_thumbnail_view.vue';
import BoulderThumbnailView from './boulder_thumbnail_view.vue';

const props = defineProps<{ crag: CragModel | null }>();
const crag = computed(() => { return toCragViewModel(props.crag); });
</script>

<template>
    <h1>{{ crag.name }}</h1>

    <div v-if="crag.lines.length > 0">
        <details>
            <summary id="all-lines-summary">All Lines</summary>
            <div class='thumbnails-container'>
                <LineThumbnailView v-for="line of crag.lines" v-bind:line="line"></LineThumbnailView>
            </div>
        </details>
    </div>

    <div v-if="crag.boulders.length > 0">
        <h2>Boulders</h2>
        <div class='thumbnails-container'>
            <BoulderThumbnailView v-for="boulder of crag.boulders" v-bind:boulder="boulder"></BoulderThumbnailView>
        </div>
    </div>
</template>
